import { Datagrid, List, TextField, EditButton, ShowButton, SimpleList } from "react-admin";
import { useMediaQuery } from "@mui/material";
import DisplayDateField from "@/components/DisplayDateField";
import { formatEventCardDateRange } from "@/utils/date-format";

export const HouseVisitEventList = () => {
  const isSmall = useMediaQuery((theme) => theme.breakpoints.down("sm"), { noSsr: true });

  return (
    <List perPage={25} sort={{ field: "fromDate", order: "DESC" }}>
      {isSmall ? (
        <SimpleList
          primaryText={(r) => r.name}
          secondaryText={(r) => `Hijri ${String(r.hijriYear ?? "—")}`}
          tertiaryText={(r) => formatEventCardDateRange(r.fromDate, r.toDate)}
          linkType="edit"
        />
      ) : (
        <Datagrid rowClick="edit">
          <TextField source="name" />
          <TextField source="hijriYear" label="Hijri year" />
          <DisplayDateField source="fromDate" label="From" />
          <DisplayDateField source="toDate" label="To" />
          <ShowButton />
          <EditButton />
        </Datagrid>
      )}
    </List>
  );
};
